/**
 * dashboard.service.ts — Layer 3: Global Admin Dashboard Domain
 *
 * Every endpoint here takes a caller-built query string (`URLSearchParams.toString()`)
 * since each dashboard widget composes a different set of filters (date range, org/user
 * ids, search, sort, pagination).
 */

import { getRequest } from './http.service';
import {
  URL_DASHBOARD_SESSION_STATS,
  URL_DASHBOARD_REAL_TIME_METRICS,
  URL_DASHBOARD_LOGINS_SUMMARY,
  URL_DASHBOARD_FEATURE_USAGE,
  URL_DASHBOARD_USER_ACTIVITY_DETAILS,
  URL_DASHBOARD_USER_SESSION_DETAILS,
  URL_DASHBOARD_EXPERIMENTAL_FEATURE_USAGE,
  URL_DASHBOARD_AGENT_USAGE,
  URL_DASHBOARD_TOP_QUESTIONS_ASKED,
  URL_DASHBOARD_AGENT_TOOL_DETAIL,
  URL_DASHBOARD_AGENT_USER_DETAIL,
  URL_DASHBOARD_AGENT_QUESTION_DETAIL,
} from './url.service';

export const fetchSessionStats = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_SESSION_STATS}?${qs}`, signal);

export const fetchRealTimeMetrics = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_REAL_TIME_METRICS}?${qs}`, signal);

export const fetchLoginsSummary = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_LOGINS_SUMMARY}?${qs}`, signal);

export const fetchFeatureUsageStats = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_FEATURE_USAGE}?${qs}`, signal);

export const fetchUserActivityDetails = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_USER_ACTIVITY_DETAILS}?${qs}`, signal);

export const fetchUserSessionDetails = (userId: string, qs?: string) =>
  getRequest(`${URL_DASHBOARD_USER_SESSION_DETAILS(userId)}${qs ? `?${qs}` : ''}`);

export const fetchExperimentalFeatureUsageStats = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_EXPERIMENTAL_FEATURE_USAGE}?${qs}`, signal);

export const fetchAgentUsageStats = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_AGENT_USAGE}?${qs}`, signal);

export const fetchTopQuestionsAsked = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_TOP_QUESTIONS_ASKED}?${qs}`, signal);

export const fetchToolDetail = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_AGENT_TOOL_DETAIL}?${qs}`, signal);

export const fetchUserDetail = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_AGENT_USER_DETAIL}?${qs}`, signal);

export const fetchQuestionDetail = (qs: string, signal?: AbortSignal) =>
  getRequest(`${URL_DASHBOARD_AGENT_QUESTION_DETAIL}?${qs}`, signal);
